export default __webpack_public_path__ + "static/char-s-18-en-c08bd17575244bb4a6c19f04f48c6b76.png";